/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Max_Hr_GreaterInputs */

const en_ui_thresholds_max_hr_greater = /** @type {(inputs: Ui_Thresholds_Max_Hr_GreaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max HR must be greater than resting HR`)
};

const de_ui_thresholds_max_hr_greater = /** @type {(inputs: Ui_Thresholds_Max_Hr_GreaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max-HF muss größer als Ruhe-HF sein`)
};

/**
* | output |
* | --- |
* | "Max HR must be greater than resting HR" |
*
* @param {Ui_Thresholds_Max_Hr_GreaterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_max_hr_greater = /** @type {((inputs?: Ui_Thresholds_Max_Hr_GreaterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Max_Hr_GreaterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_max_hr_greater(inputs)
	return de_ui_thresholds_max_hr_greater(inputs)
});